import { useMemo } from "react";

import { ProductEditForm } from "@/features/organization/product/components/product-form/ProductEditForm";
import { convertProductToFormData } from "@/features/organization/product/utils/productForm";

export const ProductCreatePage = () => {
  // Memoize so field-array row ids stay stable (see ProductEdit — avoids a false leave-confirm).
  const defaultValues = useMemo(() => convertProductToFormData(), []);
  return <ProductEditForm mode="create" title="商品登録" defaultValues={defaultValues} />;
};
